import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M2.625 6C2.625 5.70163 2.74353 5.41548 2.9545 5.2045C3.16548 4.99353 3.45163 4.875 3.75 4.875H20.25C20.5484 4.875 20.8345 4.99353 21.0455 5.2045C21.2565 5.41548 21.375 5.70163 21.375 6C21.375 6.29837 21.2565 6.58452 21.0455 6.7955C20.8345 7.00647 20.5484 7.125 20.25 7.125H3.75C3.45163 7.125 3.16548 7.00647 2.9545 6.7955C2.74353 6.58452 2.625 6.29837 2.625 6ZM12.375 10.875H3.75C3.45163 10.875 3.16548 10.9935 2.9545 11.2045C2.74353 11.4155 2.625 11.7016 2.625 12C2.625 12.2984 2.74353 12.5845 2.9545 12.7955C3.16548 13.0065 3.45163 13.125 3.75 13.125H12.375C12.6734 13.125 12.9595 13.0065 13.1705 12.7955C13.3815 12.5845 13.5 12.2984 13.5 12C13.5 11.7016 13.3815 11.4155 13.1705 11.2045C12.9595 10.9935 12.6734 10.875 12.375 10.875ZM12.375 16.875H3.75C3.45163 16.875 3.16548 16.9935 2.9545 17.2045C2.74353 17.4155 2.625 17.7016 2.625 18C2.625 18.2984 2.74353 18.5845 2.9545 18.7955C3.16548 19.0065 3.45163 19.125 3.75 19.125H12.375C12.6734 19.125 12.9595 19.0065 13.1705 18.7955C13.3815 18.5845 13.5 18.2984 13.5 18C13.5 17.7016 13.3815 17.4155 13.1705 17.2045C12.9595 16.9935 12.6734 16.875 12.375 16.875ZM23.625 15C23.6251 15.1909 23.5766 15.3786 23.4841 15.5456C23.3916 15.7125 23.2581 15.8532 23.0963 15.9544L17.0963 19.7044C16.9259 19.8108 16.7302 19.8697 16.5294 19.875C16.3287 19.8802 16.1301 19.8317 15.9545 19.7343C15.7788 19.6369 15.6324 19.4942 15.5305 19.3211C15.4286 19.1481 15.3749 18.9509 15.375 18.75V11.25C15.3749 11.0491 15.4286 10.8519 15.5305 10.6789C15.6324 10.5058 15.7788 10.3631 15.9545 10.2657C16.1301 10.1683 16.3287 10.1198 16.5294 10.125C16.7302 10.1303 16.9259 10.1892 17.0963 10.2956L23.0963 14.0456C23.2581 14.1468 23.3916 14.2875 23.4841 14.4544C23.5766 14.6214 23.6251 14.8091 23.625 15ZM20.3775 15L17.625 13.2797V16.7203L20.3775 15Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconPlaylist'

export const IconPlaylist = memo(themed(Icon))
